import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetAllPackagesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetAllPackagesQuery = { __typename?: 'Query', packagesPackages?: { __typename?: 'packagesPackagePaginator', data: Array<{ __typename?: 'packagesPackage', id: string, public_name: string, type: string }> } | null | undefined };


export const GetAllPackagesDocument = gql`
    query GetAllPackages($first: Int) {
  packagesPackages(first: $first) {
    data {
      id
      public_name
      type
    }
  }
}
    `;

/**
 * __useGetAllPackagesQuery__
 *
 * To run a query within a React component, call `useGetAllPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPackagesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetAllPackagesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPackagesQuery, GetAllPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPackagesQuery, GetAllPackagesQueryVariables>(GetAllPackagesDocument, options);
      }
export function useGetAllPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPackagesQuery, GetAllPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPackagesQuery, GetAllPackagesQueryVariables>(GetAllPackagesDocument, options);
        }
export type GetAllPackagesQueryHookResult = ReturnType<typeof useGetAllPackagesQuery>;
export type GetAllPackagesLazyQueryHookResult = ReturnType<typeof useGetAllPackagesLazyQuery>;
export type GetAllPackagesQueryResult = Apollo.QueryResult<GetAllPackagesQuery, GetAllPackagesQueryVariables>;